<template>
    <Modal title="变更角色" v-model="visible" width="700" class="my-modal top" :mask-closable="false" :footer-hide="true">
        <Transfer
            style="margin-top: 10px"
            :data="roleList"
            :titles="roleTitles"
            :target-keys="targetKeys"
            :render-format="renderRole"
            @on-change="handleChange"
            :list-style="listStyle"
        ></Transfer>

        <div class="ivu-modal-footer">
            <Button type="text" @click="visible = false">取消</Button>
            <Button type="primary" @click="save">确认</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    props: ['initList'],
    data() {
        return {
            visible: false,
            formData: {},
            roleList: [],//变更前角色数据
            targetKeys: [],//变更后角色数据
            roleTitles: ['未绑定角色', '已绑定角色'],
            listStyle: {
                width: '400px',
                height: '400px'
            },
            roleId: '',
            
        };
    },
    methods: {
        renderRole(item) {
            return item.label;
        },

        handleChange(newTargetKeys) {
            this.targetKeys = newTargetKeys;
        },

        save() {
            const formData = {
                userId: this.formData.userId,
                roleIds: this.targetKeys
            };
            this.$http({
                url: '/buz/usersExt/roles/modify',
                type: 'POST',
                data: formData,
                apiPermissionCode:'org_10_5'
            }).then(res => {
                this.visible = false;
                this.$notice.success('变更成功');
                this.initList();
            });
        },

        async open(data) {
            this.visible = true;
            this.roleList = [];
            this.targetKeys = [];
            this.roleId = data.roleId;
            await this.queryRoleList(data.buzOrganId);            
            this.$refs.form && this.$refs.form.resetFields();
            this.formData.id = data.id;
            this.formData.userId = data.userId;
        },

        queryRoleList(buzOrganId) {
            return this.$http({
                url: `/buz/rolesExt/listRoles`,
                type: 'POST',
                data:{
                    pageNo: 1,
                    pageSize: 999,
                    organizationId:buzOrganId
                }
            }).then(res => {
                let roleIds = this.roleId.split(',');         
                res.data.map((item)=>{
                    this.roleList.push({
                        ...item,
                        key: item.id,
                        label: item.name,
                        disabled:res.data.length==1 && roleIds.includes(item.id)?true:false
                    })
                    if(roleIds.includes(item.id)){
                        this.targetKeys.push(item.id)
                    }
                });
            });
        },

        viewAuthority() {
            this.$router.push({
                path: '/systemSet/accountNumManage/roleAuthority',
                query: {
                    id: this.formData.roleIds
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-transfer-list {
    width: 280px !important;
}
.my-modal {
    .item-value {
        font-size: 13px;
    }
    .text {
        font-size: 13px;
        float: right;
    }
    .ivu-icon-ios-eye {
        font-size: 18px;
        color: #a8adb7;
        top: 7px;
    }
    /deep/ .ivu-transfer-operation {
        button {
            margin-left: 0;
        }
    }
}
</style>
